<template>
  <page-header-wrapper>
    <!-- <JeepayCard title="支付通道列表"> -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" class="table-head-ground">
        <div class="table-layer">
          <a-form-item label="">
            <jeepay-text-up
              :placeholder="'通道ID'"
              :msg="searchData.wayCode"
              v-model="searchData.wayCode"
            />
          </a-form-item>
          <a-form-item label="">
            <jeepay-text-up
              :placeholder="'通道名称'"
              :msg="searchData.wayName"
              v-model="searchData.wayName"
            />
          </a-form-item>
          <!-- <a-form-item label="" >
            <a-select v-model="searchData.state" placeholder="状态" default-value="" style="width: 150px">
              <a-select-option value="">全部</a-select-option>
              <a-select-option value="1">启用</a-select-option>
              <a-select-option value="0">停用</a-select-option>
            </a-select>
          </a-form-item> -->
          <span class="table-page-search-submitButtons">
            <a-button
              type="primary"
              icon="search"
              @click="queryFunc"
              :loading="btnLoading"
            >查询</a-button>
            <a-button
              style="margin-left: 8px"
              icon="reload"
              @click="resetForm"
            >重置</a-button>
          </span>
        </div>
      </a-form>
    </div>

    <!-- 列表渲染 -->
    <JeepayTable
      @btnLoadClose="btnLoading = false"
      ref="infoTable"
      :initData="true"
      :reqTableDataFunc="reqTableDataFunc"
      :tableColumns="tableColumns"
      :searchData="searchData"
      rowKey="id"
      :tableRowCrossColor="true"
    >
      <!-- 账户24小时最大代付金额累计限制 -->
      <!-- <template slot="singleAccountPayLimitTitle">
        <a-tooltip placement="top">
          <template slot="title">
            这里是提示内容
          </template>
          <span>列名 <a-icon type="question-circle" /></span>
        </a-tooltip>
      </template> -->
      <!-- 商户费率 -->
      <template slot="rateSlot" slot-scope="{ record }">
        <a-tag color="blue">{{ record.rate }}%</a-tag>
      </template>

      <!-- 单笔最小 -->
      <template slot="minOrderAmountSlot" slot-scope="{ record }">
        <span class="amount-text">{{ formatAmount(record.minOrderAmount) }}</span>
      </template>

      <!-- 单笔最大 -->
      <template slot="maxOrderAmountSlot" slot-scope="{ record }">
        <span class="amount-text">{{ formatAmount(record.maxOrderAmount) }}</span>
      </template>

      <!-- 手续费 -->
      <template slot="fixedFeeAmountSlot" slot-scope="{ record }">
        <!-- 3% 是 商户费率 6 位手续费 -->
        <span class="fee-text">{{ formatFeeDisplay(record) }}</span>
        <!-- <span class="amount-text">[{{formatAmount(record.maxOrderAmount)+ formatAmount(record.fixedFeeAmount) }}]</span> -->
      </template>

      <!-- 账户24小时最大代付金额累计限制 -->
      <template slot="singleAccountPayLimitSlot" slot-scope="{ record }">
        <span class="amount-text">{{ formatAmount(record.singleAccountPayLimit) }}</span>
      </template>

      <!-- 状态 -->
      <template slot="stateSlot" slot-scope="{ record }">
        <a-badge
          :status="record.state === 1 ? 'processing' : 'error'"
          :text="record.state === 1 ? '启用' : '停用'"
        />
      </template>
      <!-- 类型 -->
      <template slot="payTypeSlot" slot-scope="{ record }">
        <a-tag :color="getPayTypeColor(record.payType)">{{ getPayTypeText(record.payType) }}</a-tag>
      </template>

      <!-- 通道名称 -->
      <template slot="channelNameSlot" slot-scope="{ record }">
        <!-- 没有展示‘--’ -->
        <div class="channel-name-text">{{ record.wayName || '--' }}</div>
      </template>

      <!-- 操作列 -->
      <!-- <template slot="opSlot" slot-scope="{ record }">
        <JeepayTableColumns>
          <a-button type="link" @click="viewDetail(record)">详情</a-button>
          <a-button
            type="link"
            v-if="record.state === 1"
            @click="configChannel(record)"
          >配置</a-button>
        </JeepayTableColumns>
      </template> -->
    </JeepayTable>
    <!-- </JeepayCard> -->

    <!-- 通道详情弹窗 -->
    <ChannelDetailModal
      :visible="detailVisible"
      :detailData="detailData"
      @cancel="handleDetailCancel"
    />

    <!-- 通道配置弹窗 -->
    <ChannelConfigModal
      :visible="configVisible"
      :channelData="configData"
      @submit="handleConfigSubmit"
      @cancel="handleConfigCancel"
    />
  </page-header-wrapper>
</template>

<script>
import JeepayCard from '@/components/JeepayCard/JeepayCard'
import JeepayTable from '@/components/JeepayTable/JeepayTable'
import JeepayTableColumns from '@/components/JeepayTable/JeepayTableColumns'
import JeepayTextUp from '@/components/JeepayTextUp/JeepayTextUp'
import ChannelDetailModal from './components/ChannelDetailModal'
import ChannelConfigModal from './components/ChannelConfigModal'
import { req } from '@/api/manage'
import { API_URL_MCH_PAYPASSAGE_LIST } from '@/api/channel'
import { formatAmount } from '@/utils/util'
import { getPayTypeText, getPayTypeColor } from '@/utils/constants'
import { tableColumns } from './tableColumns'

export default {
  name: 'ChannelListPage',
  components: {
    JeepayCard,
    JeepayTable,
    JeepayTableColumns,
    JeepayTextUp,
    ChannelDetailModal,
    ChannelConfigModal
  },
  data () {
    return {
      btnLoading: false,
      tableColumns: tableColumns,
      searchData: {
        channelId: '',
        channelName: '',
        state: ''
      },
      detailVisible: false,
      detailData: {},
      configVisible: false,
      configData: {}
    }
  },
  methods: {
    // 查询按钮
    queryFunc () {
      this.btnLoading = true
      this.$refs.infoTable.refTable(true)
    },

    // 重置表单
    resetForm () {
      this.$set(this.searchData, 'wayCode', null)
      this.$set(this.searchData, 'wayName', null)
      delete this.searchData.state
      this.$nextTick(() => {
        this.queryFunc()
      })
    },

    // 请求table接口数据
    reqTableDataFunc (params) {
      // 构建查询参数
      const queryParams = {
        ...params,
        channelId: this.searchData.channelId,
        channelName: this.searchData.channelName,
        state: this.searchData.state
      }

      return req.list(API_URL_MCH_PAYPASSAGE_LIST, queryParams)
    },

    // 查看详情
    viewDetail (record) {
      this.detailData = { ...record }
      this.detailVisible = true
    },

    // 关闭详情弹窗
    handleDetailCancel () {
      this.detailVisible = false
      this.detailData = {}
    },

    // 配置通道
    configChannel (record) {
      this.configData = { ...record }
      this.configVisible = true
    },

    // 处理配置提交
    handleConfigSubmit (formData) {
      // 这里处理配置提交逻辑
      console.log('配置数据:', formData)
      this.$message.success('配置成功')
      this.configVisible = false
      this.queryFunc() // 刷新列表
    },

    // 关闭配置弹窗
    handleConfigCancel () {
      this.configVisible = false
      this.configData = {}
    },

    // 格式化金额
    formatAmount,

    // 获取支付类型文本
    getPayTypeText (payType) {
      return getPayTypeText(payType)
    },

    // 获取支付类型颜色
    getPayTypeColor (payType) {
      return getPayTypeColor(payType)
    },

    // 格式化手续费显示
    formatFeeDisplay (record) {
      const rate = record.rate || 0
      const fixedFee = record.fixedFeeAmount || 0

      if (rate === 0 && fixedFee === 0) {
        return '[免费]'
      }

      let feeText = ''

      // 如果有费率
      if (rate > 0) {
        feeText += `${rate}%`
      }

      // 如果有固定费用
      if (fixedFee > 0) {
        if (feeText) {
          feeText += '+'
        }
        feeText += `${this.formatAmount(fixedFee)}/笔`
      }

      return `[${feeText}]`
    }
  }
}
</script>

<style lang="less" scoped>
.amount-text {
  font-weight: 500;
  color: #1890ff;
}

.table-page-search-wrapper {
  margin-bottom: 16px;
}
.fee-text {
  font-weight: 500;
  color: #52c41a;
  background-color: #f6ffed;
  padding: 2px 6px;
  border-radius: 4px;
  border: 1px solid #b7eb8f;
  font-size: 12px;
}
</style>
